import HighlightMatch from "../../../utilities/HighlightMatch"

export default function TrailerLocationDealerName({ location, searchTerm }) {
  const dealerName = location.attributes['dealer-name']
  const locationName = location.attributes.name

  const isDealerNameShown = () => {
    if (!dealerName) { return false }
    return dealerName.trim().toLowerCase() !== locationName?.trim().toLowerCase()
  }

  if (!isDealerNameShown()) { return null }

  return (
    <div className="flex items-center gap-1 text-sm text-grey-300 min-w-0">
      <span className="shrink-0">Dealer:</span>
      <HighlightMatch
        str={dealerName}
        match={searchTerm}
        truncate={true}
      />
    </div>
  )
}
